import { useEffect, useMemo } from 'react'
import { useCatalog } from '../contexts/CatalogContext'
import { useSignedInAccount } from '../contexts/AccountContext'
import { accountIssues, accountShape, effectivePlan } from '../utils/account'
import { log } from '../core/log'

/**
 * Eén bron voor het huidplan zoals elk scherm het toont: Sarahs persoonlijke
 * plan, of een voorlopige routine uit de bestellingen. Plus wat voor klant het
 * is (thuis, salon of allebei), zodat elk blok weet wat het moet laten zien.
 */
export function useSkinPlan() {
  const { account } = useSignedInAccount()
  const { productById, routineById, treatmentBySlug } = useCatalog()

  const plan = useMemo(() => effectivePlan(account, productById), [account, productById])
  const shape = accountShape(account)
  const routine = account.plan.routineId ? routineById(account.plan.routineId) : undefined

  // Kapotte verwijzingen melden in de console, net als bij de catalogus.
  useEffect(() => {
    const issues = accountIssues(account, {
      product: (id) => Boolean(productById(id)),
      treatment: (slug) => Boolean(treatmentBySlug(slug)),
      routine: (id) => Boolean(routineById(id)),
    })
    if (issues.length) log.warn('account', 'Verwijzingen kloppen niet:', issues)
    // Eén keer per klant melden; niet bij elke kleine wijziging aan het account.
  }, [account.customer.id]) // eslint-disable-line react-hooks/exhaustive-deps -- bewust alleen per klant

  return { ...plan, shape, routine }
}
